exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-menu[data-v-fbd6f04e] {\n  display: block;\n}\n", ""]);

// exports
